import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
    FormBuilder,
    FormGroup,
    ReactiveFormsModule,
    Validators,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { Router } from '@angular/router';
import { FuseValidators } from '@fuse/validators';
import { AuthService } from 'app/core/auth/auth.service';
import { OverlayLoaderDirective } from 'app/core/directives/overlay-loader.directive';
import { ToastrService } from 'ngx-toastr';
import { lastValueFrom } from 'rxjs';

@Component({
    selector: 'app-change-password-dialog',
    standalone: true,
    imports: [
        CommonModule,
        ReactiveFormsModule,
        MatDialogModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        MatIconModule,
        MatCheckboxModule,
        OverlayLoaderDirective,
    ],
    templateUrl: './change-password-dialog.component.html',
})
export class ChangePasswordDialogComponent implements OnInit {
    form!: FormGroup;
    loading = false;

    constructor(
        private _fb: FormBuilder,
        private _authService: AuthService,
        private _toast: ToastrService,
        private _router: Router,
        private _dialogRef: MatDialogRef<ChangePasswordDialogComponent>
    ) {}

    ngOnInit(): void {
        this.form = this._fb.group(
            {
                currentPassword: ['', Validators.required],
                newPassword: ['', Validators.required],
                confirmPassword: ['', Validators.required],
                logoutAllDevices: [false],
            },
            {
                validators: FuseValidators.mustMatch(
                    'newPassword',
                    'confirmPassword'
                ),
            }
        );
    }

    submit(): void {
        if (this.form.invalid) {
            this.form.markAllAsTouched();
            return;
        }

        this.loading = true;
        const { currentPassword, newPassword, logoutAllDevices } =
            this.form.getRawValue();

        lastValueFrom(
            this._authService.changePassword({
                currentPassword,
                newPassword,
                logoutAllDevices: !!logoutAllDevices,
            })
        )
            .then((resp: any) => {
                this._toast.success(
                    resp?.message || 'Password changed successfully'
                );
                this._dialogRef.close(true);

                if (logoutAllDevices) {
                    this._router.navigate(['/sign-out']);
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._toast.error(
                    err?.error?.message || 'Failed to change password'
                );
            })
            .finally(() => {
                this.loading = false;
            });
    }

    cancel(): void {
        this._dialogRef.close(false);
    }
}
